import { Component, OnInit } from "@angular/core";
import { HeaderTabService } from "../../shared/components/header-tabs/header-tab.service";

@Component({
    selector: "convfact-employeestabs",
    templateUrl: "./employees-tabs.component.html",
    styleUrls: ["./employees-tabs.component.css"],
    standalone: false
})
export class EmployeestabsComponent implements OnInit {
    routes: object[];

    isSelected = false;
    isResponsive: boolean;

    constructor(private headerTabService: HeaderTabService) {
        this.routes = [
            { label: "Personal", link: "/employees/list", enable: true },
            {
                label: "Gastos por empleado",
                link: "/employees/gastos",
                enable: true,
            },
            {
                label: "Nóminas",
                link: "/expense/salary",
                enable: true,
            },
            {
                label: "Registro de horas",
                link: "/employees/tiempo",
                enable: true,
            },
            { label: "Turnos", link: "/employees/turnos", enable: true },
            { label: "Bajas", link: "/employees/bajas", enable: true },
            {
                label: "Vacaciones",
                link: "/employees/vacaciones",
                enable: true,
            },
            {
                label: "Asuntos propios",
                link: "/employees/asuntos-propios",
                enable: true,
            },
            {
                label: "Roles",
                link: "/employees/childUsers",
                enable: true,
            }
        ];
    }

    ngOnInit() {
        this.headerTabService.onEventSubject.subscribe((result) => {
            const event = result.event;

            switch (event) {
                case "on-select-tab":
                    this.isSelected = true;
                    break;
                case "on-select-back":
                    this.isSelected = false;
                    break;
                case "on-change-responsive":
                    this.isResponsive = result.isResponsive;
                    break;
            }
        });
    }

    onBack() {
        this.isSelected = false;
        this.headerTabService.onEvent({ event: "on-select-back" });
    }
}
